import { render, staticRenderFns } from "./TicketProcess.vue?vue&type=template&id=6be44aca&scoped=true&"
import script from "./TicketProcess.vue?vue&type=script&lang=js&"
export * from "./TicketProcess.vue?vue&type=script&lang=js&"
import style0 from "./TicketProcess.vue?vue&type=style&index=0&id=6be44aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be44aca",
  null
  
)

export default component.exports